module.exports = "/fonts/fa-regular-400.woff2?0fe9428559f3518bb8d4917a727d133d";